<div class="settings-container">
    <form [formGroup]="assumptionsForm">
      <div class="setting-input-container">
        <p><b>YMPE Projection Rate</b></p>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            formControlName="ympeProjectionRate"
            placeholder="{{assumptions.ympeProjectionRate}}"
            class="percentage-input"
          />
          <mat-error
            >
              Please enter a value between 0 - 100
            </mat-error>
          <span class="percentage-sign">%</span>
        </mat-form-field>
      </div>
  
      <div class="setting-input-container">
        <p><b>CPP/OAS Projection Rate</b></p>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            formControlName="cppOasProjectionRate"
            placeholder="{{assumptions.cppOasProjectionRate}}"
            class="percentage-input"
          />
          <mat-error
            >
              Please enter a value between 0 - 100
            </mat-error>
          <span class="percentage-sign">%</span>
        </mat-form-field>
      </div>
  
      <div class="setting-input-container">
        <p><b>ITA Projection Rate</b></p>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            formControlName="ITAProjectionRate"
            placeholder="{{assumptions.itaProjectionRate}}"
            class="percentage-input"
          />
          <mat-error
            >
              Please enter a value between 0 - 100
            </mat-error>
          <span class="percentage-sign">%</span>
        </mat-form-field>
      </div>
  
      <div class="setting-input-container">
        <p><b>Inflation Rate</b></p>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            formControlName="inflationRate"
            placeholder="{{assumptions.inflationRate}}"
            class="percentage-input"
          />
          <mat-error
            >
              Please enter a value between 0 - 100
            </mat-error>
          <span class="percentage-sign">%</span>
        </mat-form-field>
      </div>
  
      <div class="setting-input-container">
        <p><b>Going Concern Discount Rate</b></p>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            formControlName="discountRate"
            placeholder="{{assumptions.discountRate}}"
            class="percentage-input"
          />
          <mat-error
            >
              Please enter a value between 0 - 100
            </mat-error>
          <span class="percentage-sign">%</span>
        </mat-form-field>
      </div>
  
      <div class="setting-input-container">
        <p>
          <b>Mortality:</b> 90% CPM2014 with generational projection using projection
          scale CPM-B
        </p>
      </div>
    
      <mat-dialog-actions align="center">
          <button
            mat-flat-button
            color="primary"
            [disabled]="assumptionsForm.invalid"
            type="reset"
            (click)="submit()"
          >
            UPDATE ASSUMPTIONS
          </button>
      </mat-dialog-actions>
    </form>
  </div>
  